'use client';

import { Button } from '@coolblue-development/freddy';
import selectNavigationTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentFooter/selectNavigationTrigger';
import { Mail, WhatsAppCircled } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { CallToActionType } from '@sharedTypes';
import React, { ReactNode } from 'react';

type Props = {
  ctaInfo: {
    type: CallToActionType.Email | CallToActionType.WhatsApp;
    text: string;
    href: string;
  };
};

const ctaToIcon: Partial<{ [key in CallToActionType]: ReactNode }> = {
  [CallToActionType.WhatsApp]: <WhatsAppCircled size={24} />,
  [CallToActionType.Email]: <Mail size={24} />
};

export const CallToActionsButton = ({ ctaInfo }: Props) => {
  const { trackEvent } = useAnalytics();

  const isWhatsAppButton = ctaInfo.type === CallToActionType.WhatsApp;

  const handleClick = () => {
    trackEvent(
      selectNavigationTrigger({
        sub_feature: isWhatsAppButton ? 'whatsapp_button' : 'email_button',
        index: isWhatsAppButton ? 1 : 2,
        total_indices: 2,
        url: ctaInfo.href,
        redirect: ctaInfo.text
      })
    );
  };

  return (
    <Button
      href={ctaInfo.href}
      key={ctaInfo.href}
      startIcon={ctaToIcon[ctaInfo.type]}
      component='a'
      variant='secondary'
      target={isWhatsAppButton ? '_blank' : undefined}
      onClick={handleClick}
      fullWidthUntil='md'
      sx={{ width: '32rem', '> svg': { width: '2.4rem', height: '2.4rem' } }}
    >
      {ctaInfo.text}
    </Button>
  );
};
